import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Create a light theme that matches the app's light theme configuration
const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#a31830',
      light: '#c53030',
      dark: '#8b1426',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#969BA5',
      light: '#B0B5C0',
      dark: '#7A7F8A',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#F3F4F6',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#212529',
      secondary: '#969BA5',
    },
  },
  typography: {
    fontFamily: '"Tahoma", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      color: '#a31830',
    },
    h2: {
      fontWeight: 600,
      color: '#a31830',
    },
    h3: {
      fontWeight: 600,
      color: '#212529',
    },
    h4: {
      fontWeight: 500,
      color: '#212529',
    },
    h5: {
      fontWeight: 500,
      color: '#969BA5',
    },
    h6: {
      fontWeight: 500,
      color: '#212529',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '8px',
          fontWeight: 500,
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 2px 8px rgba(163, 24, 48, 0.2)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
  },
});

interface LightThemeWrapperProps {
  children: React.ReactNode;
}

const LightThemeWrapper: React.FC<LightThemeWrapperProps> = ({ children }) => {
  return (
    <ThemeProvider theme={lightTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default LightThemeWrapper;